import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subscription } from "rxjs";
import { IUploadFile } from "../../../../domain/Upload/i-upload-file";

@Component({
  selector: "icn-file-upload",
  templateUrl: "upload.component.html",
  styleUrls: ["upload.component.scss"],
  host: {
    "[class.fail]": "uploadFile.isError",
  },
})
export class FileUploadComponent implements OnInit, OnDestroy {
  @Input() uploadFile: IUploadFile;
  @Input() canRemove = true;
  @Output() remove = new EventEmitter();

  private errorSubscription: Subscription;
  private progressSubscription: Subscription;

  constructor(private changeDetector: ChangeDetectorRef) {}

  formatPercentage() {
    return Math.floor((this.uploadFile.progress || 0) * 100) + "%";
  }

  ngOnInit() {
    this.errorSubscription = this.uploadFile.isErrorChange.subscribe(() => {
      this.changeDetector.markForCheck();
    });

    this.progressSubscription = this.uploadFile.progressChange.subscribe(() => {
      this.changeDetector.markForCheck();
    });
  }

  ngOnDestroy() {
    if (this.errorSubscription) {
      this.errorSubscription.unsubscribe();
    }
    if (this.progressSubscription) {
      this.progressSubscription.unsubscribe();
    }
  }

  onRemove() {
    this.remove.emit(this);
  }
}
